// src/components/Eventos/HeatSwitcher.jsx
import React from 'react';
import { useNavigate, generatePath } from 'react-router-dom';
import { 
  Box, 
  Button,
  Typography,
  CircularProgress,
  useMediaQuery,
  useTheme,
  Fade
} from '@mui/material';

export default function HeatSwitcher({
  competitionId,
  eventNumber,
  round,
  heats,
  currentHeat,
  isLoading = false,
  sx = {}
}) {
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  // Función para navegar a un heat específico
  const handleChange = (_, newHeat) => {
    if (!newHeat || newHeat === currentHeat || isLoading) return;
    
    const url = generatePath(
      '/:competitionId/event/:eventNumber/:round/:heat/details',
      { competitionId, eventNumber, round, heat: newHeat }
    );
    navigate(url);
  };

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, ...sx }}>
      <Typography 
        variant="subtitle2" 
        sx={{ 
          whiteSpace: 'nowrap',
          color: theme.palette.text.secondary,
          fontWeight: 500
        }}
      >
        Heat:
      </Typography>

      <Box
        sx={{
          display: 'flex',
          flexWrap: 'wrap',
          gap: 0.5
        }}
      >
        {heats.map(h => {
          const heatValue = typeof h === 'object' ? h.heat || h.id || h.nombre : h;
          return (
          <Button
            key={typeof h === 'object' ? h.id || h.heat || JSON.stringify(h) : h}
            variant={heatValue === +currentHeat ? "contained" : "outlined"}
            color={heatValue === +currentHeat ? "primary" : "secondary"}
            onClick={() => handleChange(null, heatValue)}
            disabled={isLoading}
            size={isMobile ? "small" : "medium"}
            sx={{
              minWidth: isMobile ? '36px' : '40px',
              borderRadius: '8px',
              transition: 'all 0.2s ease-in-out',
              fontWeight: 'bold',
              px: 1,
              ...(heatValue === +currentHeat && {
                transform: 'scale(1.05)',
                boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)'
              })
            }}
          >
            {typeof h === 'object' ? h.heat || h.id || h.nombre || JSON.stringify(h) : h}
          </Button>
          );
        })}
      </Box>
      
      {/* Indicador de carga */}
      {isLoading && (
        <Fade in={isLoading}>
          <Box sx={{ 
            display: 'flex', 
            alignItems: 'center', 
            ml: 1 
          }}>
            <CircularProgress size={20} thickness={4} />
            <Typography 
              variant="caption" 
              color="text.secondary" 
              sx={{ ml: 1 }}
            >
              Cargando...
            </Typography>
          </Box>
        </Fade>
      )}
    </Box>
  );
}